angular.module("appVersion", [])
.constant("version", "4.57.2026072-2.1");
